import { Outlet } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { ToastProvider } from '@xcentral/ui';
import { getMsalInstance } from '../auth/msalInstance';
import { ErrorBoundary } from '../components/ErrorBoundary';

export function RootLayout() {
  const instance = getMsalInstance();

  if (!instance) {
    // SSG render (Node) or pre-init: no MSAL/Toast context.
    // Auth-aware UI inside descendants must guard with <ClientOnly>.
    return (
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <MsalProvider instance={instance}>
        <ToastProvider>
          <Outlet />
        </ToastProvider>
      </MsalProvider>
    </ErrorBoundary>
  );
}
